var map = {
	"./thumb_1.png": 74,
	"./thumb_10.png": 75,
	"./thumb_11.png": 76,
	"./thumb_12.png": 77,
	"./thumb_2.png": 78,
	"./thumb_3.png": 79,
	"./thumb_4.png": 80,
	"./thumb_5.png": 81,
	"./thumb_6.png": 82,
	"./thumb_7.png": 83,
	"./thumb_8.png": 84,
	"./thumb_9.png": 85
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images ^\.\/.*\.png$
// module id = 18
// module chunks = 0